module.exports = __webpack_public_path__ + "img/2.ba4d2f1d.jpg";